// src/setupAxios.js
import axios from 'axios';

const setupAxios = () => {
  axios.interceptors.response.use(
    response => response, // 成功レスポンスはそのまま返す
    error => {
      // 401 Unauthorizedエラーの場合の処理をここに記述
      return Promise.reject(error);
    }
  );
};

export default setupAxios;
